import { Button, Link, Flex } from '@chakra-ui/react'
import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { baseUrl } from '../../hooks'
import { useApp } from '../../hooks/useApp'
import { useUrl } from '../../hooks/useDocuments'
import { useCloneInsuranceParams, useGetIpid } from '../../hooks/useInsuranceParams'
import { Document, Duplicate, Email, Print } from '../../icons'
import { insuranceParamsContext } from '../../layouts/Wizard'
const carkulkaUrl = process.env.REACT_APP_CARKULKA_URL
const insuranceParamsApiUrl = process.env.REACT_APP_INSURANCEPARAMS_API
const insuranceParamsUrl = `${baseUrl}/${insuranceParamsApiUrl}`

export const OffersBottomToolbar = () => {
  const { insuranceParamsId } = useContext(insuranceParamsContext)!
  const documentUrl = useUrl()
  const { app } = useApp()
  const onlyAddons = app === 'carkulka-extra'

  const { mutateAsync: getIpidLink, data: ipid } = useGetIpid(insuranceParamsId!)
  useEffect(() => { getIpidLink() }, []);

  return (
    <Flex
      sx={{
        w: '100%',
        flexWrap: 'wrap',
        justifyContent: { base: 'start', md: 'space-between' },
        gap: 2,
      }}
    >
      <Flex sx={{ gap: 2 }}>
        <Button variant="outline" as='a' href={`${insuranceParamsUrl}/CloneUrl?paramsId=${insuranceParamsId}&replacement=${false}&returnUrl=${encodeURIComponent(onlyAddons ? `${baseUrl}/carkulka/extra/wizard/1` : `${baseUrl}/carkulka/wizard/1`)}`}>
          <Duplicate color="secondary.500" />
          Klonovat nabídku
        </Button>
      </Flex>

      <Flex sx={{ gap: 2, flexWrap: 'wrap' }}>
        <Button as={Link} href={`${carkulkaUrl}/Mailing/GetCalculationEmail/${insuranceParamsId}?order=1&report=0&okapps=true`} target='_blank' variant="outline" type="button">
          <Email color="secondary.500" />
          E-mail
        </Button>

        <Button as={Link} href={`${documentUrl}/GetOffersPdf?paramsId=${insuranceParamsId}`} target='_blank' variant="outline" type="button">
          <Print color="secondary.500" />
          Tisk
        </Button>

        {ipid?.data.ipidLink &&
          <Button as={Link} href={ipid.data.ipidLink} target='_blank' variant="outline" type="button">
            <Document color="secondary.500" />
            IPID dokumenty
          </Button>
        }

      </Flex>
    </Flex>
  )
}
